module.exports = __webpack_public_path__ + "assets/008b300df75fde049ee9490401058f4c.jpg";